import React from "react";
import { Route } from "react-router-dom";
import Onboarding from "@/pages/Onboarding";
import ProfileExtended from "@/pages/ProfileExtended";
import PlanCheckout from "@/pages/PlanCheckout";
import PaymentPending from "@/pages/PaymentPending";
import ContractSign from "@/pages/ContractSign";
import { Protected } from "./Protected";

/**
 * KYC + onboarding gate routes. All wrapped with Protected(requireOnboarded=false)
 * so existing users can still be funnelled through unfinished steps.
 */
export const OnboardingRoutes = (
  <>
    <Route path="/onboarding" element={
      <Protected requireOnboarded={false}><Onboarding /></Protected>
    } />
    <Route path="/onboarding/profile" element={
      <Protected requireOnboarded={false}><ProfileExtended /></Protected>
    } />
    <Route path="/onboarding/plan" element={
      <Protected requireOnboarded={false}><PlanCheckout /></Protected>
    } />
    <Route path="/onboarding/pending" element={
      <Protected requireOnboarded={false}><PaymentPending /></Protected>
    } />
    <Route path="/onboarding/contract" element={
      <Protected requireOnboarded={false}><ContractSign /></Protected>
    } />
  </>
);
